import { buildContactMailtoUrl } from '@/constants/contact'

export interface ContactCtaModelProps {
  productName?: string
  label?: string
}

const DEFAULT_LABEL = 'Falar por e-mail'

export function useContactCtaModel({
  productName,
  label,
}: ContactCtaModelProps) {
  return {
    label: label ?? DEFAULT_LABEL,
    href: buildContactMailtoUrl(productName),
  }
}
